import { render, staticRenderFns } from "./AddEditSizeDialog.vue?vue&type=template&id=4c9d8368&scoped=true"
import script from "./AddEditSizeDialog.vue?vue&type=script&lang=js"
export * from "./AddEditSizeDialog.vue?vue&type=script&lang=js"
import style0 from "./AddEditSizeDialog.vue?vue&type=style&index=0&id=4c9d8368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d8368",
  null
  
)

export default component.exports